module.exports = __webpack_public_path__ + "static/media/status-failed.1924df87.svg";